<template>
  <div class="main-container">
    <Button type="primary" class="btn export" @click="exportDetailData">导出</Button>
    <Button class="back-btn" type="primary" ghost @click="back()">返回</Button>
    <div class="title">
      <span>{{ $route.query.title }}</span>
    </div>

    <div class="loading" v-show="loading">
      <Spin fix>
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
      </Spin>
    </div>

    <div v-show="!loading">
      <template v-if="isShowTable12">
        <div class="table-title">基本法收益项明细</div>
        <div class="tableBox">
          <detailTable12 @showTable="showTable" :showPage="false"></detailTable12>
        </div>
      </template>
      <template v-if="isShowTable1">
        <div class="table-title">基本法外首期基础费用（个险）</div>
        <div class="tableBox">
          <detailTable1 @showTable="showTable"></detailTable1>
        </div>
      </template>

      <template v-if="isShowTable2">
        <div class="table-title">基本法外首期基础费用（团险）</div>
        <div class="tableBox">
          <detailTable2 @showTable="showTable"></detailTable2>
        </div>
      </template>

      <template v-if="isShowTable15">
        <div class="title">基本法扣款</div>
        <div class="tableBox">
          <detailTable15 @showTable="showTable" :showPage="false"></detailTable15>
        </div>
      </template>


      <template v-if="isShowTable3">
        <div class="table-title">基本法外续期基础费用 (个险)</div>
        <div class="tableBox">
          <detailTable3 @showTable="showTable"></detailTable3>
        </div>
      </template>

      <template v-if="isShowTable4">
        <div class="table-title">首年后置费用</div>
        <div class="tableBox">
          <detailTable4 @showTable="showTable"></detailTable4>
        </div>
      </template>

      <template v-if="isShowTable5">
        <div class="table-title">首年限时加费活动</div>
        <div class="tableBox">
          <detailTable5 @showTable="showTable"></detailTable5>
        </div>
      </template>

      <template v-if="isShowTable6">
        <div class="table-title">团队长首期管理费（个险）</div>
        <div class="tableBox">
          <detailTable6 @showTable="showTable"></detailTable6>
        </div>
      </template>

      <template v-if="isShowTable7">
        <div class="table-title">团队长首期管理费（团险）</div>
        <div class="tableBox">
          <detailTable7 @showTable="showTable"></detailTable7>
        </div>
      </template>

      <template v-if="isShowTable8">
        <div class="table-title">团队长续期管理费（个险）</div>
        <div class="tableBox">
          <detailTable8 @showTable="showTable"></detailTable8>
        </div>
      </template>

      <template v-if="isShowTable9">
        <div class="table-title">团队长首年后置（个险）</div>
        <div class="tableBox">
          <detailTable9 @showTable="showTable"></detailTable9>
        </div>
      </template>

      <div v-for="(item, index) in activityList" :key="index">
        <template>
          <div class="table-title">{{ item.actName }}</div>
          <!-- 增员-无门槛 -->
          <div class="tableBox" v-if="item.type == 1 && item.mode == 1">
            <detailTable10 :actId="item.actId"></detailTable10>
          </div>
          <!-- 增员-梯度 -->
          <div class="tableBox" v-if="item.type == 1 && item.mode == 2">
            <detailTable16 :actId="item.actId" :productType="item.productType"></detailTable16>
          </div>
          <!-- 出单-梯度 -->
          <div class="tableBox" v-if="item.type == 2 && item.mode == 2">
            <detailTable13 :actId="item.actId" :productType="item.productType"></detailTable13>
          </div>
          <!-- 出单-无门槛 -->
          <div class="tableBox" v-if="item.type == 2 && item.mode == 1">
            <detailTable14 :actId="item.actId" :productType="item.productType"></detailTable14>
          </div>
          <!-- 签约活动 -->
          <div class="tableBox" v-if="item.type == 3 && item.mode == 2">
            <detailTable17 :actId="item.actId" :productType="item.productType"></detailTable17>
          </div>
        </template>
      </div>

      <template v-if="isShowTable11">
        <div class="table-title">加扣款</div>
        <div class="tableBox">
          <detailTable11 @showTable="showTable"></detailTable11>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { common, pageTool } from '@/api/mixins';
import detailTable1 from './components/detailTable1.vue';
import detailTable2 from './components/detailTable2.vue';
import detailTable3 from './components/detailTable3.vue';
import detailTable4 from './components/detailTable4.vue';
import detailTable5 from './components/detailTable5.vue';
import detailTable6 from './components/detailTable6.vue';
import detailTable7 from './components/detailTable7.vue';
import detailTable8 from './components/detailTable8.vue';
import detailTable9 from './components/detailTable9.vue';
import detailTable10 from './components/detailTable10.vue';
import detailTable11 from './components/detailTable11.vue';
import detailTable12 from './components/detailTable12.vue';
import detailTable13 from './components/detailTable13.vue';
import detailTable14 from './components/detailTable14.vue';
import detailTable16 from './components/detailTable16.vue';
import detailTable15 from './components/detailTable15.vue';
import detailTable17 from './components/detailTable17.vue';
export default {
  mixins: [common, pageTool],
  components: {
    detailTable1,
    detailTable2,
    detailTable3,
    detailTable4,
    detailTable5,
    detailTable6,
    detailTable7,
    detailTable8,
    detailTable9,
    detailTable10,
    detailTable11,
    detailTable12,
    detailTable13,
    detailTable14,
    detailTable15,
    detailTable16,
    detailTable17,
  },
  data() {
    return {
      title: '',
      activityList: [],
      isShowTable1: true,
      isShowTable2: true,
      isShowTable3: true,
      isShowTable4: true,
      isShowTable5: true,
      isShowTable6: true,
      isShowTable7: true,
      isShowTable8: true,
      isShowTable9: true,
      isShowTable11: true,
      isShowTable12: true,
      isShowTable15: true,
      loading: true
    };
  },
  created() {
    this.getActivityList();
  },
  beforeCreate() {
    document.querySelector('body').setAttribute('style', 'overflow: auto;');
  },
  methods: {
    showTable(data, type) {
      this.loading = true;
      if (type == 1) {
        this.isShowTable1 = data;
      } else if (type == 2) {
        this.isShowTable2 = data;
      } else if (type == 3) {
        this.isShowTable3 = data;
      } else if (type == 4) {
        this.isShowTable4 = data;
      } else if (type == 5) {
        this.isShowTable5 = data;
      } else if (type == 6) {
        this.isShowTable6 = data;
      } else if (type == 7) {
        this.isShowTable7 = data;
      } else if (type == 8) {
        this.isShowTable8 = data;
      } else if (type == 9) {
        this.isShowTable9 = data;
      } else if (type == 11) {
        this.isShowTable11 = data;
      } else if (type == 12) {
        this.isShowTable12 = data;
      } else if (type == 15) {
        this.isShowTable15 = data;
      }
      setTimeout(() => {
        this.loading = false;
      }, 1500);
    },

    // 获取活动列表
    getActivityList() {
      this.$http({
        url: '/buz/userSalaryDetails/getAct',
        type: 'POST',
        data: {
          reportId: this.$route.query.reportId,
          userId: this.$route.query.userId
        }
      }).then(res => {
        this.activityList = res.data;
      });
    },

    exportDetailData() {
      let pageType = this.$route.query.pageType;
      // 提现
      if (!this.$units.pointAction('offline_81_6_2') && pageType == 'withdrawal') {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      // ok保提现
      if (!this.$units.pointAction('offline_81_7_btn3') && pageType == 'withdrawalOK') {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      // ok保异常单
      if (!this.$units.pointAction('offline_81_8_btn3') && pageType == 'riskOrderOK') {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      // 薪酬
      if (!this.$units.pointAction('offline_81_2_3') && pageType == 'pay') {
        this.$notice.error('无权操作，请联系您的上级');
        return;
      }
      let { reportId, userId, tabVal, orgId } = this.$route.query;
      let data = {
        reportId
      };
      if (tabVal == 1) {
        data.userId = userId;
      } else if (tabVal == 2) {
        data.orgId = orgId;
      }
      this.$units.downloadFile('/buz/userSalaryDetails/exportByDetail', data, 'POST');
    }
  }
};
</script>

<style lang="scss" scoped>
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.loading {
  position: absolute;
  width: 98%;
  height: 95%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
}
.export {
  position: absolute;
  right: 100px;
}
.back-btn {
  position: absolute;
  right: 20px;
}
.title {
  font-weight: bold;
  font-size: 18px;
  font-weight: 800;
  margin-top: 20px;
}
.table-title {
  font-size: 16px;
  margin-bottom: 15px;
  margin-top: 20px;
}
.tableBox {
  margin-bottom: 80px;
}
</style>
